import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
// import FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
// import { useFormik } from "formik";
import { useFormik, FormikProvider, FieldArray } from "formik";
// import * as Yup from "yup";
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';
var Barcode = require('react-barcode');



// ✅ Moved OUTSIDE the main component so it's a stable reference for createRoot
const BarcodeComponent = ({ barcodeData }) => {
  return (
    <div style={{ padding: '10px' }}>
      <Barcode
        value={barcodeData}
        format="CODE128"
        width={3}        // ✅ increase bar width
        height={100}     // ✅ taller = easier to scan
        margin={10}      // ✅ more quiet zone around barcode
        displayValue={true}
        fontSize={12}
      />
    </div>
  );
};

BarcodeComponent.propTypes = {
  barcodeData: PropTypes.string.isRequired,
};
const ProductionOutputEdit = () => {
  let { id } = useParams();
  const [locationLoading, setLocationLoading] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [productLists, setproductLists] = useState([]);
  const [permission, setPermission] = useState({});

  const [valueContents, setValueContents] = useState([]);
  const [palletsTypesLists, setPalletsTypesLists] = useState([]);

  const [value, setValue] = useState({});


  const [lotNumberOptions, setLotNumberOptions] = useState([]);

  // Debounce function
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  // Debounced search function
  const debouncedSearchLotNumbers = debounce(async (searchValue) => {
    if (searchValue && searchValue.length >= 3) {
      try {
        const response = await axios.post("/production-output/search-lot-numbers",
          { search: searchValue },
          { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken } }
        );

        if (response.data.code === 200) {
          const lots = response.data.data.lot_numbers || [];
          const formattedLots = lots.map(lot => ({
            label: lot.lot_number,
            value: lot.lot_number,
            ...lot
          }));
          setLotNumberOptions(formattedLots);
        } else {
          setLotNumberOptions([]);
        }
      } catch (error) {
        console.error("Error fetching lot numbers:", error);
        setLotNumberOptions([]);
      }
    }
  }, 500); // 500ms delay

  // // Also add a function to handle datalist selection
  const handleLotNumberSelection = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue) {
      // Check if the selected value exists in the options
      const selectedOption = lotNumberOptions.find(opt => opt.value === selectedValue);
      if (selectedOption) {
        formik.setFieldValue("lot_number", selectedValue);
        getSupplierByLotNumber(selectedValue);
      } else {
        formik.setFieldValue("lot_number", selectedValue);
        if (selectedValue.length >= 3) {
          debouncedSearchLotNumbers(selectedValue);
        }
      }
    }
  };


  const formik = useFormik({
    initialValues: {
      id: id,
      date_time: value.date_time,
      location: value.location,
      shift: value.shift,
      shift_date: value.shift_date,
      lot_number: value.toal_lot_number,
      supplier: value.supplier_name,
      calibre: value.calibre,
      packaging_type: value.packaging_type,
      number_of_boxes: value.number_of_boxes,
      net_weight: value.net_weight,
      pallet_type: value.pallet_type,
      remark: value.remark,
      order: value.order,
      ggn_number: value.ggn_number,
      contents: valueContents,


    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      axios.post("/production-output/update", values, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
        .then((response) => {
          setSubmitting(false);
          delete backendErrors['error'];
          $("#form-submit").text("Update Production Output");
          if (response.data.code === 200) {
            // setBackendSuccess(response.data.message);
            toast.success(response.data.message);

             if (response.data.data.production.total_output_type == 'Semi Finished') {
                
                handleDownload(response.data.data.production);
              }

              
            var barcode_number = value.barcode_number;
            var productions_output_id = value.id

            console.log(barcode_number);
            console.log(productions_output_id);
             

            axios.get(`/production-output/pdf/${productions_output_id}`, {
              responseType: 'blob',
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
            }).then(response => {
              const blob = new Blob([response.data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              let file_name = barcode_number + '.pdf';
              link.download = file_name;
              link.click();


            }).catch(error => {
              console.error('Error downloading PDF:', error);
            });
            setTimeout(() => {
              window.location.href = "/production-output";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }

        })
        .catch((error) => {
          toast.error(error);
        });
    },
  });



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  useEffect(() => {
    setPermission(FindModuleById(51));
    console.log(permission);


    axios.post("/helpers/production_types_consumable", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, }
    ).then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.production_types;
        let productslisting = products.map((customer, index) => ({
          label: customer.consumable_name,
          value: customer.id,
          key: `address-${index}`,
        }));
        setPalletsTypesLists(productslisting);

      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });

    axios.post("/products/listing-category-type", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, }
    ).then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.products;
        let productslisting = products.map((customer, index) => ({
          label: customer.productname,
          value: customer.id,
          key: `address-${index}`,
        }));
        setproductLists(productslisting);

      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`/production-output/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          toast.error(response.data.data.production);
          setValue(response.data.data.production);
          setValueContents(response.data.data.production.items);



        }
      })
      .catch((error) => {
        console.log(error);
      });


  }, [id]);



  useEffect(() => {
    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let productslisting = response.data.data.locations;

          //let farmers = response.data.data.farmers;
          let locations = productslisting.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farmer-${index}`,
          }));

          setLocationLoading(locations);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });




  }, []);



  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };

  //   let palletsTypesLists =[

  //     { value: '1', label: "10 KG" },
  //     { value: '2', label: "20 KG" },
  //     { value: '3', label: "Plastic Box 10 KG" },
  // ]
  let outputType = [

    { value: '2', label: "Semi Finished" },
    { value: '1', label: "Finished" },
  ]


  const customHandleDateShift = (dateTimeValue) => {

    console.log('here auto ');
    const dt = dateTimeValue || formik.values.date_time;
    if (!dt) return;

    const parts = dt.includes("T") ? dt.split("T") : dt.split(" ");
    const datePart = parts[0]; // "YYYY-MM-DD"
    const timePart = parts[1]; // "HH:MM"

    if (!timePart) return;

    const [hourStr, minuteStr] = timePart.split(":");
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    const totalMinutes = hour * 60 + minute;

    // Shift boundaries
    const shift1Start = 7 * 60 + 30;  // 07:30 = 450
    const shift1End = 19 * 60 + 30; // 19:30 = 1170
    const shift2Start = 19 * 60 + 31; // 19:31 = 1171
    const shift2End = 7 * 60 + 29;  // 07:29 = 449

    if (totalMinutes >= shift1Start && totalMinutes <= shift1End) {
      // ✅ Shift 1: 07:30 – 19:30 → current day
      formik.setFieldValue("shift", "1");
      formik.setFieldValue("shift_date", datePart);

    } else if (totalMinutes >= shift2Start) {
      // ✅ Shift 2 evening: 19:31 – 23:59 → current day
      formik.setFieldValue("shift", "2");
      formik.setFieldValue("shift_date", datePart);

    } else if (totalMinutes <= shift2End) {
      // ✅ Shift 2 midnight: 00:00 – 07:29 → previous day
      formik.setFieldValue("shift", "2");
      const date = new Date(datePart + "T00:00:00");
      date.setDate(date.getDate() - 1);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      formik.setFieldValue("shift_date", `${year}-${month}-${day}`);
    }
  };


  // Function to get supplier by lot number
  const getSupplierByLotNumber = async (lotNumber) => {
    if (!lotNumber) return;

    try {
      const response = await axios.post("/production-output/get-supplier-by-lot",
        { lot_number: lotNumber },
        { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken } }
      );

      if (response.data.code === 200) {
        // Automatically select the first supplier if available

        formik.setFieldValue("supplier", response.data.data.supplier);



        // Optional: Show success message
        // toast.success(`Supplier found: ${supplier}`);
      } else if (response.data.code === 404) {
        // No supplier found
        formik.setFieldValue("supplier", "");
        // Optional: Show warning message
        // toast.warning("No supplier found for this lot number");
      }
    } catch (error) {
      console.error("Error fetching supplier:", error);
      formik.setFieldValue("supplier", "");
      // Optional: Show error message
      // toast.error("Error fetching supplier information");
    }
  };



  const handleSemiFinishedClick = async (index) => {
    const currentRow = formik.values.contents[index];

    if (!currentRow.product) {
      toast.error("Please select a product");
      return;
    }
    if (!currentRow.number_of_boxes || currentRow.number_of_boxes <= 0) {
      toast.error("Please enter number of boxes");
      return;
    }
    if (!currentRow.gross_weight || currentRow.gross_weight <= 0) {
      toast.error("Please enter gross weight");
      return;
    }

    if (!window.confirm("Submit this production output?")) {
      return;
    }

    const button = document.querySelector(`#semi-finished-btn-${index}`);
    if (button) {
      button.disabled = true;
      button.innerHTML = 'Submitting...';
    }

    try {
      const response = await axios.post("/production-output/update", formik.values, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });

      if (response.data.code === 200) {
        toast.success(response.data.message);

        var barcode_number = value.barcode_number;
        var productions_output_id = value.id

        console.log(barcode_number);
        console.log(productions_output_id);

        handleDownload(response.data.data.production);

        axios.get(`/production-output/pdf/${productions_output_id}`, {
          responseType: 'blob',
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
        }).then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          let file_name = barcode_number + '.pdf';
          link.download = file_name;
          link.click();
          setTimeout(() => {
            window.location.href = "/production-output";
          }, 1000);

        }).catch(error => {
          console.error('Error downloading PDF:', error);
        });


      } else if (response.data.code === 422) {
        setBackendErrors(response.data.error);
        toast.error("Please check the form for errors");
      } else {
        toast.error(response.data.message || "Error submitting data");
      }
    } catch (error) {
      console.error("Error submitting:", error);
      toast.error("Error submitting production output");
    } finally {
      if (button) {
        button.disabled = false;
        button.innerHTML = '<i className="fa fa-print"></i>';
      }
    }
  };

  const handleDownload = (barcode_data) => {
    const originalBarcodeNumber = barcode_data.barcode_number;

    let get_contents = '';
    get_contents += '<div id="div-print" style="padding: 5px;">';

    get_contents += '<div style="text-align: center; margin-bottom: 10px;">';
    get_contents += '<h3 style="font-size: 36px; margin-bottom: 10px;">Semi Finished Output Details</h3>';
    get_contents += '<hr style="border: 2px solid #000; margin: 20px 0;">';
    get_contents += '</div>';

    get_contents += '<table style="width:100%; border-collapse: collapse; margin-bottom: 10px;">';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5; width: 35%;">Barcode#</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + originalBarcodeNumber + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Date And Time</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.date_time || '') + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Shift Date</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.shift_date || '') + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Shift</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.shift || '') + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Location</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.location_name ? barcode_data.location_name.title : '') + '</td></tr>';

    get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Package Type</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.packaging_name || '') + '</td></tr>';
     get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Lot Number</td>';
    get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + barcode_data.toal_lot_number + '</td></tr>';
    get_contents += '</table><br/>';

    get_contents += '<h5 style="font-size: 24px; margin: 10px 0; text-align: left;">Items Details</h5>';
    get_contents += '<table style="width:100%; border-collapse: collapse; margin-bottom: 10px;">';
    get_contents += '<thead>';
    get_contents += '<tr style="background-color: #f5f5f5;">';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Product</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Number Of Boxes</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Gross Weight (KG)</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Boxes weight (KG)</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Pallets Weight (KG)</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Net Weight (KG)</th>';
    get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Output Type</th>';
    get_contents += '</tr>';
    get_contents += '</thead><tbody>';

    if (barcode_data.contents && Array.isArray(barcode_data.contents)) {
      barcode_data.contents.forEach((item, index) => {
        const rowBgColor = index % 2 === 0 ? '#ffffff' : '#f9f9f9';
        get_contents += `<tr style="background-color: ${rowBgColor};">`;
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${item.product_name || ''}</td>`;
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${item.number_of_boxes || ''}</td>`;

        const grossWeight = typeof item.gross_weight === 'number' ? item.gross_weight.toFixed(2) : '0';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${grossWeight}</td>`;

        const boxWeight = typeof item.box_weight === 'number' ? item.box_weight.toFixed(2) : '0';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${boxWeight}</td>`;

        const palletWeight = typeof item.pallet_weight === 'number' ? item.pallet_weight.toFixed(2) : '0';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${palletWeight}</td>`;

        const netWeight = typeof item.net_weight === 'number' ? item.net_weight.toFixed(2) : '0';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${netWeight}</td>`;

        const outputTypeLabel = item?.output_type === 1 ? 'Finished' : 'Semi Finished';
        get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${outputTypeLabel}</td>`;
        get_contents += '</tr>';
      });
    }

    get_contents += '</tbody></table><br/>';

    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);

    const root = createRoot(tempDiv);
    // ✅ BarcodeComponent is now stable (defined outside) so createRoot works correctly
    root.render(<BarcodeComponent barcodeData={originalBarcodeNumber} />);

    // ✅ Increased timeout to 800ms to ensure barcode SVG fully renders
    setTimeout(() => {
      const barcodeHtml = tempDiv.innerHTML;
      get_contents += '<div style="text-align: center; margin-top: 30px;">';
      get_contents += barcodeHtml;
      get_contents += '</div>';
      get_contents += '</div>';

      const width = 500;
      const height = 600;
      const widthInPixels = width * 3.779527559;
      const heightInPixels = height * 3.779527559;
      const left = (window.screen.width - widthInPixels) / 2;
      const top = (window.screen.height - heightInPixels) / 2;
      const windowFeatures = `width=${widthInPixels},height=${heightInPixels},left=${left},top=${top}`;

      const printWindow = window.open('', '', windowFeatures);
      printWindow.document.open();
      printWindow.document.write('<html><head><title>Production Output - ' + originalBarcodeNumber + '</title>');
      printWindow.document.write('<style>');
      printWindow.document.write('@media print { body { margin: 0; padding: 20px; } }');
      printWindow.document.write('table { page-break-inside: avoid; }');
      printWindow.document.write('tr { page-break-inside: avoid; page-break-after: avoid; }');
      printWindow.document.write('</style>');
      printWindow.document.write('</head><body style="font-family: Arial, sans-serif; margin: 0; padding: 20px;">');
      printWindow.document.write(get_contents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);

      document.body.removeChild(tempDiv);
    }, 800); // ✅ Increased from 500ms to 800ms
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Output</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-output">Production Output</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Edit Production Output
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission && permission.update === 1 && (
                    <div className="card-body">
                      <h4 className="card-title">Production Output</h4>
                      <FormikProvider value={formik}>
                        <form action="#" onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Date Time</label>
                                <input
                                  type="datetime-local"
                                  name="date_time"
                                  value={formik.values.date_time}
                                  className="form-input form-control input-error"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    customHandleDateShift(e.target.value, formik.values.shift); // ✅ pass both

                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.date_time && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date_time}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group packaging_type status">
                                <label>Packaging Type</label>
                                {palletsTypesLists.length > 0 && (
                                  <Select

                                    className="w-100"
                                    value={palletsTypesLists.find(option => option.value == formik.values.packaging_type) || null} // Ensure correct format
                                    name="packaging_type"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("packaging_type", selectedOption);


                                    }}
                                    onBlur={formik.handleBlur}
                                    options={palletsTypesLists}
                                    placeholder="Select"


                                  />
                                )}
                                <small>
                                  {backendErrors.pallet_type && (
                                    <span className="form-error mt-1">
                                      {backendErrors.pallet_type}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>


                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Location</label>
                                {locationLoading.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                                    name="location"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("location", selectedOption);
                                      //getCustomerGNN(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={locationLoading}
                                    placeholder="Select"

                                  />
                                )}

                                <small>
                                  {backendErrors.location && (
                                    <span className="form-error mt-1">
                                      {backendErrors.location}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Shift (1 ot 2)</label>
                                <input
                                  type="text"
                                  onKeyPress={(event) => {
                                    // Allow only numbers (0-9)
                                    if (!/^[0-9]$/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  name="shift"
                                  value={formik.values.shift}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    customHandleDateShift(formik.values.date_time, e.target.value); // ✅ pass both

                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.shift && (
                                    <span className="form-error mt-1">
                                      {backendErrors.shift}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Shift Date</label>
                                <input
                                  type="date"
                                  className="form-input form-control"
                                  name="shift_date"
                                  id="shift_date"
                                  value={formik.values.shift_date}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    //setDefaultDate(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}

                                />
                                <small>
                                  {backendErrors.shift_date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.shift_date}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>


                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Lot Number</label>
                                <div style={{ position: "relative" }}>
                                  <input
                                    type="text"
                                    name="lot_number"
                                    id="lot_number"
                                    className="form-input form-control"
                                    value={formik.values.lot_number}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      formik.setFieldValue("lot_number", value);
                                      customHandleInput(e);
                                      handleLotNumberSelection(e);

                                      if (value && value.length >= 3) {
                                        debouncedSearchLotNumbers(value);
                                      } else if (value.length < 3 && value.length > 0) {
                                        setLotNumberOptions([]);
                                      }

                                      if (!value) {
                                        formik.setFieldValue("supplier", "");
                                      }
                                    }}
                                    onBlur={(e) => {
                                      // Delay to allow click on suggestion
                                      setTimeout(() => {
                                        formik.handleBlur(e);
                                        if (e.target.value && e.target.value.length >= 3) {
                                          getSupplierByLotNumber(e.target.value);
                                        }
                                      }, 200);
                                    }}
                                    placeholder="Search Lot Number..."
                                    autoComplete="off"
                                  />
                                  {lotNumberOptions.length > 0 && (
                                    <div className="suggestions-dropdown" style={{
                                      position: "absolute",
                                      top: "100%",
                                      left: 0,
                                      right: 0,
                                      backgroundColor: "#fff",
                                      border: "1px solid #ddd",
                                      borderRadius: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      zIndex: 1000,
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                    }}>
                                      {lotNumberOptions.map((option, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            padding: "8px 12px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #f0f0f0"
                                          }}
                                          onClick={() => {
                                            formik.setFieldValue("lot_number", option.value);
                                            setLotNumberOptions([]);
                                            getSupplierByLotNumber(option.value);
                                          }}
                                          onMouseEnter={(e) => e.target.style.backgroundColor = "#f5f5f5"}
                                          onMouseLeave={(e) => e.target.style.backgroundColor = "#fff"}
                                        >
                                          {option.label}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                                {/* <small className="text-muted">
                                  {lotNumberOptions.length > 0 ? `${lotNumberOptions.length} lot number(s) found` : "Enter at least 3 characters to search for lot numbers"}
                                </small> */}
                                <small>
                                  {backendErrors.lot_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.lot_number}
                                    </span>
                                  )}
                                </small>
                              </div>

                              <div className="form-group status">
                                <label>Supplier</label>

                                <input
                                  type="text"
                                  className="form-input form-control"
                                  name="supplier"
                                  id="supplier"
                                  readOnly
                                  value={formik.values.supplier}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    // setDefaultDate(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}

                                />


                                <small>
                                  {backendErrors.supplier && (
                                    <span className="form-error mt-1">
                                      {backendErrors.supplier}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>


                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Items
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="contents"
                            render={(arrayHelpers) => (
                              <div>
                                {console.log(arrayHelpers)}
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th style={{ width: '24%' }} >Product</th>
                                      {/* <th style={{ width: '12%' }} >Lot Number</th> */}
                                      <th style={{ width: '10%' }} >Number Of Boxes</th>
                                      <th style={{ width: '11%' }} >Gross Weight (KG)</th>
                                      <th style={{ width: '11%' }} >Boxes weight (KG)</th>
                                      <th style={{ width: '11%' }} >Pallets Weight (KG)</th>
                                      <th style={{ width: '11%' }} >Net Weight (KG)</th>
                                      <th style={{ width: '15%' }} >Output Type</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formik.values.contents.map(
                                      (friend, index) => (
                                        <tr key={index}>

                                          <td style={{ width: '24%' }} >
                                            <div className="form-group status">
                                              {productLists.length > 0 && (
                                                <Select
                                                required
                                                  name={`contents[${index}].product`}
                                                  options={productLists}
                                                  value={productLists.find(option => option.value == formik.values.contents[index].product) || null} // Ensure correct format
                                                  onChange={(selectedOption) => {
                                                    formik.setFieldValue(`contents[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                    customHandleInput({
                                                      target: {
                                                        name: `contents[${index}].product`,
                                                        value: selectedOption.value, // ✅ Ensure only value is passed
                                                      },
                                                    });
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  placeholder="Select"
                                                  className="w-100"
                                                />
                                              )}
                                            </div>
                                          </td>

                                          <td style={{ width: '10%' }} >
                                            <div className="form-group">
                                              <input
                                               required
                                                type="text"
                                                placeholder="Boxes"
                                                className="form-input form-control"
                                                name={`contents[${index}].number_of_boxes`}
                                                value={formik.values.contents[index].number_of_boxes}
                                                onChange={(event) => {
                                                  formik.handleChange(event);
                                                  const updatedNumberOfBoxes = event.target.value ? parseFloat(event.target.value) : 0;
                                                  const grossWeight = formik.values.contents[index].gross_weight ? parseFloat(formik.values.contents[index].gross_weight) : 0;
                                                  const boxWeight = formik.values.contents[index].box_weight ? parseFloat(formik.values.contents[index].box_weight) : 0;
                                                  const palletWeight = formik.values.contents[index].pallet_weight ? parseFloat(formik.values.contents[index].pallet_weight) : 0;
                                                  const netWeight = grossWeight - (updatedNumberOfBoxes * boxWeight + palletWeight);
                                                  const newNetWeight = netWeight.toFixed(1);
                                                  formik.setFieldValue(`contents[${index}].net_weight`, newNetWeight);
                                                }}
                                                onKeyPress={(event) => {
                                                  if (!/^[0-9]$/.test(event.key)) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                              />
                                            </div>
                                          </td>

                                          <td style={{ width: '11%' }} >
                                            <div className="form-group">
                                              <div className="input-group">
                                                <input type="text"
                                                 required
                                                  name={`contents[${index}].gross_weight`}
                                                  value={formik.values.contents[index].gross_weight}
                                                  onKeyPress={(event) => {
                                                    if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    formik.handleChange(event);
                                                    const updatedGrossWeight = event.target.value ? parseFloat(event.target.value) : 0;
                                                    const numberOfBoxes = formik.values.contents[index].number_of_boxes ? parseFloat(formik.values.contents[index].number_of_boxes) : 0;
                                                    const boxWeight = formik.values.contents[index].box_weight ? parseFloat(formik.values.contents[index].box_weight) : 0;
                                                    const palletWeight = formik.values.contents[index].pallet_weight ? parseFloat(formik.values.contents[index].pallet_weight) : 0;
                                                    const netWeight = updatedGrossWeight - (numberOfBoxes * boxWeight + palletWeight);
                                                    const newNetWeight = netWeight.toFixed(1);
                                                    formik.setFieldValue(`contents[${index}].net_weight`, newNetWeight);
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  className="form-control"
                                                  placeholder="Gross Weight"
                                                />

                                              </div>
                                            </div>
                                          </td>

                                          <td style={{ width: '11%' }} >
                                            <div className="form-group">
                                              <div className="input-group">
                                                <input type="text"
                                                 required
                                                  name={`contents[${index}].box_weight`}
                                                  value={formik.values.contents[index].box_weight}
                                                  onKeyPress={(event) => {
                                                    if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    formik.handleChange(event);
                                                    const updatedBoxWeight = event.target.value ? parseFloat(event.target.value) : 0;
                                                    const grossWeight = formik.values.contents[index].gross_weight ? parseFloat(formik.values.contents[index].gross_weight) : 0;
                                                    const numberOfBoxes = formik.values.contents[index].number_of_boxes ? parseFloat(formik.values.contents[index].number_of_boxes) : 0;
                                                    const palletWeight = formik.values.contents[index].pallet_weight ? parseFloat(formik.values.contents[index].pallet_weight) : 0;
                                                    const netWeight = grossWeight - (numberOfBoxes * updatedBoxWeight + palletWeight);
                                                    const newNetWeight = netWeight.toFixed(1);
                                                    formik.setFieldValue(`contents[${index}].net_weight`, newNetWeight);
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  className="form-control"
                                                  placeholder="Box Weight"
                                                />

                                              </div>
                                            </div>
                                          </td>

                                          <td style={{ width: '12%' }} >
                                            <div className="form-group">
                                              <div className="input-group">
                                                <input type="text"
                                                 required
                                                  name={`contents[${index}].pallet_weight`}
                                                  value={formik.values.contents[index].pallet_weight}
                                                  onKeyPress={(event) => {
                                                    if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    formik.handleChange(event);
                                                    const updatedPalletWeight = event.target.value ? parseFloat(event.target.value) : 0;
                                                    const grossWeight = formik.values.contents[index].gross_weight ? parseFloat(formik.values.contents[index].gross_weight) : 0;
                                                    const numberOfBoxes = formik.values.contents[index].number_of_boxes ? parseFloat(formik.values.contents[index].number_of_boxes) : 0;
                                                    const boxWeight = formik.values.contents[index].box_weight ? parseFloat(formik.values.contents[index].box_weight) : 0;
                                                    const netWeight = grossWeight - (numberOfBoxes * boxWeight + updatedPalletWeight);
                                                    const newNetWeight = netWeight.toFixed(1);
                                                    formik.setFieldValue(`contents[${index}].net_weight`, newNetWeight);
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  className="form-control"
                                                  placeholder="Pallet Weight"
                                                />

                                              </div>
                                            </div>
                                          </td>

                                          <td style={{ width: '12%' }} >
                                            <div className="form-group">
                                              <div className="input-group">
                                                <input type="text"
                                                 required
                                                  name={`contents[${index}].net_weight`}
                                                  value={formik.values.contents[index].net_weight}
                                                  onKeyPress={(event) => {
                                                    if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  onChange={formik.handleChange}
                                                  onBlur={formik.handleBlur}
                                                  className="form-control"
                                                  placeholder="Net Weight"

                                                />

                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status" style={{ display: 'flex' }}>
                                              <Select
                                               required
                                                name={`contents[${index}].output_type`}
                                                options={outputType}
                                                value={outputType.find(option => option.value == formik.values.contents[index].output_type) || null} // Ensure correct format
                                                onChange={(selectedOption) => {
                                                  formik.setFieldValue(`contents[${index}].output_type`, selectedOption.value); // ✅ Store only value in Formik
                                                  customHandleInput({
                                                    target: {
                                                      name: `contents[${index}].output_type`,
                                                      value: selectedOption.value, // ✅ Ensure only value is passed
                                                    },
                                                  });
                                                }}
                                                onBlur={formik.handleBlur}
                                                placeholder="Select"
                                                className="w-100"
                                              />
                                              {formik.values.contents[index].output_type == '2' && (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-primary"
                                                  onClick={() => handleSemiFinishedClick(index)}
                                                  title="Add semi-finished details"
                                                >
                                                  <i className="fa fa-print" />
                                                </button>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          />
                          <small>
                            {backendErrors.status && (
                              <span className="form-error mt-1">
                                {backendErrors.status}
                              </span>
                            )}
                          </small>
                          <div className="text-end mt-4">
                            <button
                              type="submit" id="form-submit"
                              className="btn btn-primary"
                              disabled={formik.isSubmitting}
                            >
                              Update Production Output
                            </button>
                          </div>
                        </form>
                      </FormikProvider>

                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionOutputEdit;
